export const user = {
  customerName: '㈱DUMMY',
  isAbejaAdmin: true,
  role: 'Owner'
}
export const customer = {
  name: '㈱DUMMY',
  customerId: 1,
  country: 'JP',
  externalServiceId: 'dummy_dummy_dummy_dummy',
  phone: '0123-45-6789',
  postCode: '123-4567',
  purchaseType: 'Self',
  representativeUserName: 'Dummy Saito',
  address: '東京都港区北青山 2-14-4',
}
export const licenseList = [
  {
    paymentDate: '2020-01-27 23:33:28',
    orderId: 1,
    customerId: 1,
    customerName: '㈱DUMMY',
    licenseType: 'Standard',
    purchaseType: 'Self',
    numberOfLicense: 50,
    numberOfUsingLicense: 15
  },
  {
    paymentDate: '2020-02-27 23:33:28',
    orderId: 2,
    customerId: 2,
    customerName: '㈱TST',
    licenseType: 'Trial',
    purchaseType: 'PartnerReferral',
    numberOfLicense: 10,
    numberOfUsingLicense: 8
  },
  {
    paymentDate: '2020-03-27 23:33:28',
    orderId: 3,
    customerId: 3,
    customerName: 'Test.inc',
    licenseType: 'Free',
    purchaseType: 'PartnerSales',
    numberOfLicense: 180,
    numberOfUsingLicense: 98
  },
  {
    paymentDate: '2020-04-27 23:33:28',
    orderId: 4,
    customerId: 4,
    customerName: '株式会社カービィ',
    licenseType: 'Standard',
    purchaseType: 'DirectSales',
    numberOfLicense: 2000,
    numberOfUsingLicense: 1438
  },
]
export const adminLicenseList = [
  {
    paymentDate: '2020-01-27 23:33:28',
    orderId: 1,
    customerId: 1,
    customerName: '㈱DUMMY',
    licenseType: 'Standard',
    purchaseType: 'Self',
    numberOfLicense: 50,
    numberOfUsingLicense: 15
  },
  {
    paymentDate: '2020-02-27 23:33:28',
    orderId: 2,
    customerId: 2,
    customerName: '㈱TST',
    licenseType: 'Trial',
    purchaseType: 'PartnerReferral',
    numberOfLicense: 10,
    numberOfUsingLicense: 8
  },
  {
    paymentDate: '2020-03-27 23:33:28',
    orderId: 3,
    customerId: 3,
    customerName: 'Test.inc',
    licenseType: 'Free',
    purchaseType: 'PartnerSales',
    numberOfLicense: 180,
    numberOfUsingLicense: 98
  },
  {
    paymentDate: '2020-04-27 23:33:28',
    orderId: 4,
    customerId: 4,
    customerName: '株式会社カービィ',
    licenseType: 'Standard',
    purchaseType: 'DirectSales',
    numberOfLicense: 2000,
    numberOfUsingLicense: 1438
  },
]
export const selectedCustomer = ( name: string ) => {
  const target = [{
    name: '㈱DUMMY',
    customerId: 1,
    country: 'JP',
    externalServiceId: 'dummy_dummy_dummy_dummy',
    phone: '0123-45-6789',
    postCode: '123-4567',
    purchaseType: 'Self',
    representativeUserName: 'Dummy Saito',
    address: '東京都港区北青山 2-14-4',
  }, {
    name: '㈱TST',
    customerId: 2,
    country: 'US',
    externalServiceId: 'dummy1_dummy2_dummy3_dummy4',
    phone: '0123-44-5555',
    postCode: '123-4567',
    purchaseType: 'PartnerReferral',
    representativeUserName: 'Dummy Saito',
    address: '東京都港区北青山 2-14-4',
  }, {
    name: 'Test.inc',
    customerId: 3,
    country: 'SG',
    externalServiceId: 'dummy2_dummy3_dummy4_dummy5',
    phone: '0123-45-6789',
    postCode: '123-4567',
    purchaseType: 'DirectSales',
    representativeUserName: 'Dummy Saito',
    address: '東京都港区北青山 2-14-4',
  }, {
    name: '株式会社カービィ',
    customerId: 4,
    country: 'JP',
    externalServiceId: 'dummy3_dummy4_dummy5_dummy6',
    phone: '0123-45-6789',
    postCode: '123-4567',
    purchaseType: 'PartnerSales',
    representativeUserName: 'Dummy Saito',
    address: '東京都港区北青山 2-14-4',
  }]
  return target.find((obj) => obj.name === name)
}
